import { Filter } from '../services/types/services'
import { createProductsSlice } from './slices/products'
import { createContextSlice } from './slices/context'
import { ClearFiltersProps, createFiltersSlice } from './slices/filters'
import { createSharedSlice } from './slices/shared'
import { QueryProductsProps } from './slices/products/types'
import { ApplyIntegerFilterProps } from './slices/filters/types'

export type SearchStoreState = ReturnType<typeof createContextSlice> &
  ReturnType<typeof createFiltersSlice> &
  ReturnType<typeof createProductsSlice> &
  ReturnType<typeof createSharedSlice> & { launchpadAnalytics?: boolean }

export enum TrackingActionsEnum {
  toggleFiltersMenu = 'toggleFiltersMenu',
  toggleFiltersCategory = 'toggleFiltersCategory',
  clearFilters = 'clearFilters',
  clearFiltersWhenNoResults = 'clearFiltersWhenNoResults',
  sortBy = 'sortBy',
  queryProducts = 'queryProducts',
  loadMoreProducts = 'loadMoreProducts',
  changeDepartment = 'changeDepartment',
  applyIntegerFilter = 'applyIntegerFilter',
  loadPage = 'loadPage',
}

export type TrackingActionTypes = keyof typeof TrackingActionsEnum

export type TrackingPayload =
  | Filter[]
  | string[]
  | ClearFiltersProps[]
  | QueryProductsProps[]
  | boolean[]
  | ApplyIntegerFilterProps[]
  | number[]

export type StoreProviderProps = {
  initialState?: Partial<SearchStoreState>
}
